var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    rx: 4,
    fill: "#C6FB55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_612_8974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.25 7.75H11.75C11.3522 7.75 10.9706 7.90804 10.6893 8.18934C10.408 8.47064 10.25 8.85218 10.25 9.25V22.75C10.25 23.1478 10.408 23.5294 10.6893 23.8107C10.9706 24.092 11.3522 24.25 11.75 24.25H28.25C28.6478 24.25 29.0294 24.092 29.3107 23.8107C29.592 23.5294 29.75 23.1478 29.75 22.75V9.25C29.75 8.85218 29.592 8.47064 29.3107 8.18934C29.0294 7.90804 28.6478 7.75 28.25 7.75ZM28.25 9.25V12.25H11.75V9.25H28.25Z",
    fill: "#141046"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_612_8974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkdownIcon);
export default __webpack_public_path__ + "static/media/markdown-icon.93112f41d7dec8f7e6ba9f1770a381f6.svg";
export { ForwardRef as ReactComponent };